"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickCaptureService = void 0;
const Common_1 = require("./Common");
const Logger_1 = __importStar(require("./Logger"));
class ClickCaptureService {
    setCaptureSelectors(selectors) {
        this.customCaptureSelectors = new Set(selectors.length > 0 ? selectors : ClickCaptureService.AUTO_CLICK_CAPTURE_SELECTORS);
    }
    constructor(contextService, elementCaptureService) {
        this.contextService = contextService;
        this.elementCaptureService = elementCaptureService;
        this.adpCaptureSelectors = new Set(ClickCaptureService.ADP_CLICK_CAPTURE_SELECTORS);
        this.customCaptureSelectors = new Set();
        this.capture = this.capture.bind(this);
    }
    /** Adds the click event listener to the document event emitter */
    connect() {
        if (document.querySelector(`[${Common_1.HTML_ATTR_CAPTURE_CLICK_LEGACY}]`) != null) {
            Logger_1.default.warn(`Capturing click event with deprecated "${Common_1.HTML_ATTR_CAPTURE_CLICK_LEGACY}", use "${Common_1.HTML_ATTR_CAPTURE_CLICK}" instead`);
        }
        document.addEventListener("click", this.capture);
    }
    /** Removes the click event listener from the document event emitter */
    disconnect() {
        document.removeEventListener("click", this.capture);
    }
    /** Handles the emitted click events
     * Only handles if the element matches any of query selectors.
     */
    capture({ target }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(target instanceof Element)) {
                return;
            }
            const allSelectors = [
                ...(this.contextService.context.config.captureDocumentClickEvents ? this.adpCaptureSelectors : []),
                ...this.customCaptureSelectors,
            ];
            const captured = this.elementCaptureService.getTarget(target, allSelectors);
            if (!captured) {
                Logger_1.default.debug("No selector matches:", target, allSelectors);
                return;
            }
            Logger_1.default.debug("Capturing click event on:", captured.target, "with selector:", captured.selector);
            yield this.contextService.tracker.trackInternal({
                eventType: "CLICK_COMPONENT",
                trackInfo: this.elementCaptureService.collectFacets(captured.target),
                autoCaptureContext: {
                    targetElement: target,
                    capturedElement: captured.target,
                    selector: captured.selector,
                },
            });
        });
    }
}
ClickCaptureService.ADP_CLICK_CAPTURE_SELECTORS = [
    `[${Common_1.HTML_ATTR_CAPTURE_CLICK}]`,
    `[${Common_1.HTML_ATTR_CAPTURE_CLICK_LEGACY}]`,
];
ClickCaptureService.AUTO_CLICK_CAPTURE_SELECTORS = [
    "[onclick]",
    "[role=button]",
    "[role=link]",
    "a[href]",
    "button",
    "input[type=button]",
    "input[type=image]",
    "input[type=reset]",
    "input[type=submit]",
];
__decorate([
    (0, Logger_1.logApi)()
], ClickCaptureService.prototype, "connect", null);
__decorate([
    (0, Logger_1.logApi)()
], ClickCaptureService.prototype, "disconnect", null);
exports.ClickCaptureService = ClickCaptureService;
